import { Asset, labelForAsset } from "@model/assets/Asset"
import  React from "react"
import { ImageUrls } from "@ui/common/images/ImageUrls"
import { ExternalRoutes } from "@lib/Routes";
import { Chip, Tooltip } from "@material-ui/core"
import { CopyIcon } from "@ui/common/images/InlinedSvgs"


export function SerialNumberBox({serialNumber}: {serialNumber: string | undefined}): JSX.Element {
    return (
        <div className="serial-number-box">
            <span className="text-muted-foreground">Serial / VIN: </span>{serialNumber} 
            <Tooltip title="Copy to clipboard">
                <button className="copy-button" onClick={() => {navigator.clipboard.writeText(serialNumber ?? "")}}>
                    <CopyIcon />
                </button>
            </Tooltip>
        </div>
    )
}

export function ActiveStatusComponent({status}: {status: boolean | undefined}): JSX.Element | null {
    const className = status ? "status-dot active" : "status-dot inactive";
    const statusText = status ? "Active" : "Inactive";
    return <div style={{display:"inline-flex", alignItems: "baseline", paddingLeft: "5px"}}><div className={className}></div> {statusText}</div>;
}

export function AssetIdentifierComponent({asset}: {asset: Asset | null}): JSX.Element {
    return (
    <div className="asset-identifier-component-container">
        <div style={{display:"inline-flex", flexDirection:"column"}}>
            <div style={{display:"inline-flex"}}>
                <a href={ExternalRoutes.SmartHubAsset(asset?.id ?? 0)} target="_blank" style={{ textDecoration: 'none' }}>
                        {asset?.label}
                </a>                           
            </div>
            <div style={{display:"inline-flex", flexDirection: "row", gap: "10px"}}>
                <SerialNumberBox serialNumber={asset?.serialNumber} />
                <ActiveStatusComponent status={asset?.active} />
                {asset?.AssetTag?.map((tag, index) => (
                    <Chip key={index} label={tag} size="small" style={{backgroundColor: 'grey', color: 'white'}} />
                ))}
            </div>     
        </div>
    </div>)
}
